import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive, toRef } from 'vue-demi'
import type { WidgetID } from '../script-manager/common'
import { useComponentV2 } from '../composables/component-v2'
import type { RecaptchaV2State } from '../api'

interface SlotApi {
  /**
   * widget id
   */
  widgetId: WidgetID | undefined
  /**
   * reCAPTCHA state
   */
  state: RecaptchaV2State

  isError: boolean
  isExpired: boolean
  isVerified: boolean

  /**
   * reset reCAPTCHA
   */
  reset: () => void
  /**
   * execute challenge
   */
  execute: () => void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ChallengeV2',
  props: {
    as: { default: 'div' },
    widgetId: {},
    badge: { default: 'bottomright' },
    tabindex: {},
    autoExecute: { type: Boolean, default: true },
    modelValue: {}
  },
  emits: ["load", "error", "expired", "success", "update:widgetId", "update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const { root, reset, widgetID, state, execute, isError, isExpired, isVerified } = useComponentV2(
  {
    size: 'invisible',
    badge: props.badge,
    tabindex: props.tabindex,
  },
  toRef(props, 'modelValue'),
  emit
)

const slotApi: SlotApi = reactive({
  execute,
  widgetId: widgetID,
  state,
  reset,
  isError,
  isExpired,
  isVerified,
})

function onClick() {
  if (props.autoExecute) {
    execute()
  }
}

__expose({
  execute,
  reset,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.as), { onClick: onClick }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(_unref(slotApi)))),
      _createElementVNode("div", {
        ref_key: "root",
        ref: root
      }, null, 512)
    ]),
    _: 3
  }))
}
}

})